import { render } from "./EventsView.vue?vue&type=template&id=a604cdec&scoped=true"
import script from "./EventsView.vue?vue&type=script&lang=js"
export * from "./EventsView.vue?vue&type=script&lang=js"

import "./EventsView.vue?vue&type=style&index=0&id=a604cdec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a604cdec"]])

export default __exports__